import useCalendar from "../context/useCalendar";
import ChangeConsultation from "./ChangeConsultation";
import EditProfile from "./EditProfile";
import Profile from "./Profile";
import { MainWrapper, InnerWrapper, ProfileName } from "./StyledComponents";

const DoctorInfos = () => {
    const {
        profile: { doctorName, id, doctorPic },
        calendarSettings: { withoutEditProfile },
    } = useCalendar();
    return (
        <MainWrapper>
            <InnerWrapper>
                <Profile imgageSource={doctorPic} />
                <ProfileName>{doctorName}</ProfileName>
                {!withoutEditProfile && <EditProfile profileId={id} />}
                <div />
                <ChangeConsultation />
            </InnerWrapper>
        </MainWrapper>
    );
};

export default DoctorInfos;
